export interface Article {
  id: string;
  title: string;
  category: string;
  excerpt: string;
  content: string;
  image: string;
  author: string;
  date: string;
  readTime: string;
  tags: string[];
}

export const categories = [
  { key: '剧情攻略', label: '剧情攻略', icon: 'ri-guide-line' },
  { key: '角色解析', label: '角色解析', icon: 'ri-user-heart-line' },
  { key: '主题评测', label: '主题评测', icon: 'ri-star-line' },
  { key: '感动结局', label: '感动结局', icon: 'ri-heart-pulse-line' },
  { key: '玩家评价', label: '玩家评价', icon: 'ri-chat-smile-2-line' },
];

export const articles: Article[] = [
  {
    id: 'story-guide-complete',
    title: '缘之空完整剧情攻略：从相遇至离别的全分支详解',
    category: '剧情攻略',
    excerpt: '全面解析缘之空各条剧情线的分支选择与结局条件，帮助玩家体验春日野悠与每位女主角的完整故事。从共通线到个人线，每一个关键选择都将引领你走向不同的命运交织。',
    content: `<p>《缘之空》作为Sphere社最具代表性的视觉小说作品，以其细腻的情感描写和大胆的题材探索，在视觉小说爱好者中留下了深刻的印象。本文将为您详细解析游戏中的每一条剧情分支与选择条件。</p>

<h2>共通线：奥木染町的夏天</h2>
<p>故事始于男主角春日野悠与妹妹春日野穹因父母意外离世，被迫回到故乡奥木染町。在这个宁静的乡村小镇，悠遇到了青梅竹马天女目瑛、神社巫女依媛奈绪、班长渚一叶、以及神秘少女乃木坂初佳等人。</p>
<p>共通线的主要选择集中在前三天，每一个看似微小的决定都会影响后续可进入的个人路线。玩家需要特别注意与各角色的互动时机——在关键场景中选择正确的选项，才能解锁对应角色的个人路线。</p>

<h2>天女目瑛线：秘密与救赎</h2>
<p>瑛是悠在奥木染町的青梅竹马，性格开朗活泼，总是带着温暖的笑容。然而在阳光的外表下，她隐藏着不为人知的家族秘密。在这条路线中，玩家将逐步揭开瑛的身世之谜，见证她与悠之间从友情到爱情的转变。</p>
<p><strong>关键选择点：</strong>第二天在神社遇到瑛时，选择「陪她一起打扫」；第三天放学后选择「去神社找瑛」；第五天在得知瑛的秘密后选择「我相信你」。</p>

<h2>依媛奈绪线：纯白的巫女之恋</h2>
<p>奈绪是奥木染神社的巫女，气质清冷高雅，内心却敏感而温柔。她的路线探讨了传统与现代的冲突，以及个人意志与家族责任的平衡。悠的出现让奈绪开始重新审视自己的人生选择。</p>
<p><strong>关键选择点：</strong>第二天选择「去神社参拜」；第四天在奈绪被家族施压时选择「我想帮助奈绪」；第七天在祭典之夜选择「牵起奈绪的手」。</p>

<h2>渚一叶线：水面下的真心</h2>
<p>作为班级的班长，一叶给人的印象是认真负责、品学兼优。然而在这条路线中，玩家将发现她隐藏的柔软一面，以及她对悠长久以来的暗恋之情。这是一段关于勇气与坦诚的青春物语。</p>
<p><strong>关键选择点：</strong>第一天在学校选择「和一叶一起整理图书室」；第四天文化祭准备中选择「帮一叶分担工作」；第六天在一叶表白时选择「我也喜欢你」。</p>

<h2>乃木坂初佳线：意外的邂逅</h2>
<p>初佳是突然出现在奥木染町的神秘少女，她的真实身份和来到小镇的目的都是谜。这条路线充满了悬疑元素，随着剧情推进，玩家将逐渐了解初佳的过去和她与奥木染町的深厚渊源。</p>
<p><strong>关键选择点：</strong>第三天在街上遇到初佳时选择「追上她」；第五天在得知初佳的真实身份后选择「无论如何我都会站在你这边」。</p>

<h2>获取所有结局的终极指南</h2>
<p>要解锁游戏的全部结局（包括好结局、普通结局和隐藏结局），建议按照以下顺序进行攻略：瑛线 → 奈绪线 → 一叶线 → 初佳线。每条路线完成后，新的选项和隐藏剧情将在后续周目中解锁。建议在每条路线的重要分支点进行存档，以便快速回溯和尝试不同选择。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Summer%20rural%20Japanese%20countryside%20with%20traditional%20shrine%20and%20cherry%20blossom%20petals%20floating%20in%20golden%20sunset%20light%2C%20soft%20romantic%20atmosphere%2C%20anime%20visual%20novel%20aesthetic%2C%20warm%20nostalgic%20tones%2C%20gentle%20gradient%20sky%2C%20pastoral%20beauty&width=1600&height=900&seq=yosuga-story-01&orientation=landscape',
    author: '悠之空编辑部',
    date: '2026-07-15',
    readTime: '12分钟',
    tags: ['剧情攻略', '分支选择', '全结局', '新手向'],
  },
  {
    id: 'kasugano-sora-analysis',
    title: '春日野穹角色深度解析：超越血脉的纯粹之爱',
    category: '角色解析',
    excerpt: '深入分析缘之空最具争议也最令人动容的角色——春日野穹。从性格成因到情感转变，再到她在整个故事中的象征意义，全面解读这位银发少女的内心世界。',
    content: `<p>春日野穹——这个名字在视觉小说爱好者中几乎无人不晓。作为《缘之空》的核心女主角，穹的设定本身就是一个巨大的争议点，但正是这种争议性，使她成为了整个作品中最为复杂、最为动人的角色。</p>

<h2>孤独的银发少女</h2>
<p>穹的性格塑造有着深厚的心理学基础。幼年丧母、父亲常年不在身边，使得穹对哥哥悠产生了极度的依赖。这种依赖在青春期逐渐转化为一种超越普通兄妹关系的复杂情感。她害怕失去悠——这几乎是她在世界上唯一的精神支柱。</p>
<p>穹的银发和苍白肤色暗示着她的脆弱与独特。在视觉小说的人物设计中，这种外形特征往往指向角色的"异质性"——她们与常人不同，也因此承受着常人无法理解的痛苦。</p>

<h2>依赖与占有：穹的心理动机</h2>
<p>从心理学角度分析，穹的行为模式表现出典型的"焦虑型依恋"。她的任性、独占欲、以及对悠周围其他女性的敌意，根源都在于内心深处对被抛弃的恐惧。理解这一点后，穹的许多看似"自私"的行为就变得可以理解了——她并非不知道自己的感情是不被世俗接受的，但她别无选择。</p>

<h2>争议与救赎</h2>
<p>缘之空之所以引发巨大争议，很大程度上源于穹线的处理方式。但如果我们抛开道德判断，纯粹从情感层面去理解这个故事，会发现其中蕴含着关于"爱"的本质的深刻探讨：爱是否可以被定义？爱的边界在哪里？当爱与伦理发生冲突时，我们应该如何抉择？</p>
<p>穹的结局——无论哪个版本——都充满了悲剧性的美感。她与悠之间那超越世俗的情感，成为了视觉小说史上最令人难忘的故事之一。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Silver%20haired%20anime%20girl%20in%20white%20dress%20standing%20by%20window%20with%20sunlight%20streaming%20through%2C%20melancholic%20expression%2C%20soft%20ethereal%20atmosphere%2C%20watercolor%20style%20background%2C%20gentle%20warm%20lighting%2C%20poetic%20composition&width=1600&height=900&seq=yosuga-sora-01&orientation=landscape',
    author: '悠之空编辑部',
    date: '2026-07-20',
    readTime: '15分钟',
    tags: ['角色解析', '春日野穹', '心理学分析', '深度解读'],
  },
  {
    id: 'amatsume-akira-analysis',
    title: '天女目瑛角色解析：阳光下的秘密与永恒的守护',
    category: '角色解析',
    excerpt: '瑛作为悠的青梅竹马，她那灿烂笑容背后隐藏着怎样的故事？本文深度解读天女目瑛的角色设定、心理变化，以及她在整个缘之空故事中的独特地位。',
    content: `<p>天女目瑛是《缘之空》中看似最为开朗的角色，但正如许多优秀的角色塑造所展示的那样，最灿烂的笑容往往掩藏着最深沉的心事。</p>

<h2>表层的阳光与深层的阴影</h2>
<p>瑛在共通线中展现出的活泼与热情，让她成为了玩家最先产生好感的角色之一。她总是第一个向悠伸出援手的人，总是用她标志性的笑容化解尴尬的氛围。然而，随着剧情的深入，我们逐渐发现瑛的家庭背景远比表面复杂——她的双亲早已离异，她与母亲的关系微妙而紧张。</p>
<p>这种"表里不一"的角色设定是缘之空叙事技巧的精华所在：通过逐步揭示角色的真实处境，让玩家在获得信息的过程中不断修正对角色的认知，从而产生更深层次的情感共鸣。</p>

<h2>救赎与被救赎</h2>
<p>瑛线的核心主题是"相互救赎"。悠的出现帮助瑛正视自己的家庭问题，而瑛的陪伴则让悠在失去父母之后重新找到了生活的温暖。两人的关系不是单向的拯救，而是双向的治愈。这种平等的情感关系设计，让瑛线成为了许多玩家心中最健康、最美好的CP。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Cheerful%20anime%20girl%20with%20short%20brown%20hair%20in%20school%20uniform%20standing%20at%20traditional%20Japanese%20shrine%20gate%2C%20warm%20afternoon%20sunlight%2C%20gentle%20breeze%20blowing%20cherry%20blossoms%2C%20nostalgic%20summer%20atmosphere&width=1600&height=900&seq=yosuga-akira-01&orientation=landscape',
    author: '悠之空编辑部',
    date: '2026-07-22',
    readTime: '10分钟',
    tags: ['角色解析', '天女目瑛', '青梅竹马', '双向救赎'],
  },
  {
    id: 'theme-review-deep',
    title: '缘之空主题深度评测：禁忌之恋背后的存在主义思考',
    category: '主题评测',
    excerpt: '超越表面的争议，从存在主义哲学、社会学和文学批评的角度，深度剖析缘之空的核心主题：孤独、羁绊、自由意志与命运的抗争。',
    content: `<p>如果仅仅将《缘之空》理解为一部"禁断之恋"的猎奇作品，那将是对这部作品最大的误解。在它充满争议的表象之下，隐藏着对现代人精神困境的深刻洞察。</p>

<h2>主题一：现代社会的孤独与连结</h2>
<p>奥木染町这个设定本身就是一种隐喻——一个被现代化遗忘的乡村小镇，成为了一群孤独灵魂的避难所。悠和穹失去了双亲，瑛有着破碎的家庭，奈绪被传统束缚，一叶隐藏着真实的自我……每个角色都代表着一种现代社会中常见的孤独形态。</p>
<p>缘之空通过角色之间的情感连结，探讨了"人如何在与他人建立深度关系的过程中找到存在的意义"这一哲学命题。这与存在主义心理学家欧文·亚隆的理论不谋而合——人际关系是克服存在性孤独的最重要途径。</p>

<h2>主题二：禁忌作为叙事工具</h2>
<p>缘之空中的"禁忌"元素，与其说是为了猎奇，不如说是作者刻意设置的情感压强环境。当社会规范与个人情感发生根本冲突时，角色被迫做出极端选择，这种极端情境反而更能揭示人性的本质。这让我想起古希腊悲剧中的类似手法——禁忌之恋在文学史上从来都是探索人性边界的经典母题。</p>

<h2>主题三：自由意志与命运</h2>
<p>游戏中多条分支路线的设计，本身就是对"自由意志"这一主题的巧妙呼应。玩家通过选择决定了角色的命运，但那些被预先设定的选项又暗示着某种不可抗拒的命运之力。这种设计让玩家在享受叙事的同时，也成为了对"选择与命运"这一哲学主题的亲身体验者。</p>

<h2>综合评价</h2>
<p>缘之空在叙事结构、角色塑造和主题深度上都达到了相当高的水准。它的争议性恰恰证明了它触及了某些重要的社会与伦理议题。对于能够以开放心态去理解这部作品的玩家来说，缘之空提供的不仅是一段动人的故事，更是一次关于爱、孤独与存在意义的精神旅程。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Philosophical%20contemplation%20scene%20with%20open%20book%20on%20wooden%20desk%2C%20scattered%20cherry%20blossom%20petals%2C%20warm%20candlelight%2C%20old%20library%20atmosphere%2C%20soft%20golden%20glow%2C%20introspective%20mood%2C%20literary%20aesthetic&width=1600&height=900&seq=yosuga-theme-01&orientation=landscape',
    author: '悠之空编辑部',
    date: '2026-08-01',
    readTime: '18分钟',
    tags: ['主题评测', '深度分析', '哲学思考', '文学批评'],
  },
  {
    id: 'ending-touching-moments',
    title: '缘之空最令人感动的五个结局时刻：泪崩预警',
    category: '感动结局',
    excerpt: '盘点缘之空各条路线中最催人泪下的结局场景，从瑛线的温暖重逢到穹线的命运抉择，那些让你在深夜独自流泪的瞬间。',
    content: `<p>作为一部以情感描写见长的视觉小说，《缘之空》在结局的处理上展现了极高的叙事水准。以下是我们评选出的五个最令人感动的结局时刻，建议备好纸巾。</p>

<h2>第五名：一叶线 — 图书室里的告白</h2>
<p>在经历了漫长的暗恋和自我怀疑之后，一叶终于在图书室里向悠坦白了她的心意。这个场景没有华丽的辞藻，没有戏剧性的转折，只有两颗真诚的心在夕阳的余晖下缓缓靠近。那种"平凡中的真挚"反而最令人动容。</p>

<h2>第四名：初佳线 — 真相揭露之夜</h2>
<p>当初佳的真实身份被揭开的那一刻，所有的谜团瞬间串联成一条清晰的线索。原来她的到来不是偶然，而是命运的必然。在雨中，初佳流着泪向悠坦白一切，而悠的选择是——紧紧拥抱她。</p>

<h2>第三名：奈绪线 — 祭典之夜的誓言</h2>
<p>夏日的祭典，漫天的烟花，身着浴衣的奈绪在神社的古老神木下向悠许下了永远的誓言。这个场景将日式美学中的"物哀"精神发挥到了极致——在最美的瞬间，感受到的却是即将失去的忧伤。</p>

<h2>第二名：瑛线 — 樱花树下的重逢</h2>
<p>当瑛终于解决了家庭的困扰，重新站在奥木染町的樱花树下时，悠早已在那里等候多时。两人相视而笑，没有言语，因为所有的话都在那段分离的时光里说完了。樱花如雪般飘落，新的故事才刚刚开始。</p>

<h2>第一名：穹线 — 那个夏天的选择</h2>
<p>没有任何一个结局能像穹线的结局那样让人久久无法释怀。在那个夏日的黄昏，悠和穹面对着世俗的审判和内心的挣扎，最终做出了他们的选择。无论你如何看待这个结局，它的情感冲击力都是无与伦比的。那些关于爱、牺牲和勇气的画面，将永远铭刻在每一位玩家的记忆中。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Romantic%20sunset%20scene%20at%20Japanese%20summer%20festival%20with%20fireworks%20in%20sky%2C%20two%20silhouettes%20standing%20under%20cherry%20tree%2C%20warm%20orange%20and%20pink%20gradient%20sky%2C%20nostalgic%20and%20bittersweet%20atmosphere%2C%20anime%20film%20still%20style&width=1600&height=900&seq=yosuga-ending-01&orientation=landscape',
    author: '悠之空编辑部',
    date: '2026-08-05',
    readTime: '14分钟',
    tags: ['感动结局', '催泪', '名场面', '结局盘点'],
  },
  {
    id: 'player-review-roundup',
    title: '缘之空玩家评价汇总：十年沉淀后的理性回望',
    category: '玩家评价',
    excerpt: '收集并整理了来自中日两国玩家社区对缘之空的评价，从最初的激烈争议到十年后的理性审视，看看玩家们是如何评价这部作品的。',
    content: `<p>距离《缘之空》首次发布已经过去了相当长的时间，足够让人们以更加平和、理性的心态来回望这部曾经引发轩然大波的作品。本文整理了来自各大玩家社区的评价，试图呈现一个多元而全面的视角。</p>

<h2>中国玩家社区的演变</h2>
<p>在缘之空刚刚进入中国玩家视野时，争议主要集中在穹线的伦理问题上。许多初次接触此类题材的玩家表示"难以接受"，但也有不少玩家为作品的艺术价值辩护。</p>
<p>十年之后，中国玩家社区对缘之空的评价发生了明显的变化。越来越多的人开始从叙事技巧、角色塑造和主题深度等角度来评价这部作品，而非仅仅聚焦于争议性内容。一位资深玩家在知乎上的评论被广泛引用："缘之空最厉害的地方不在于它写了什么，而在于它怎么写的。"</p>

<h2>日本玩家的持续讨论</h2>
<p>在日本，缘之空被视为Sphere社的巅峰之作。日本玩家更关注作品中"物哀"美学的体现，以及对乡村生活的诗意描绘。在批评空间等平台上，缘之空的综合评分始终维持在较高水平，尤其是在"音乐"和"剧情"两个维度上获得了极高的评价。</p>

<h2>争议的价值</h2>
<p>有趣的是，很多最初对缘之空持批评态度的玩家，在多年后重新游玩时给出了不同的评价。这种"时间检验"效应恰恰说明了缘之空作为一部艺术作品的价值——它经得起时间的考验，甚至随着读者阅历的增长而展现出更丰富的层次。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20desk%20setup%20with%20laptop%20displaying%20review%20page%2C%20warm%20coffee%20on%20side%2C%20soft%20natural%20light%20from%20window%2C%20clean%20professional%20atmosphere%2C%20editorial%20photography%20style&width=1600&height=900&seq=yosuga-review-01&orientation=landscape',
    author: '悠之空编辑部',
    date: '2026-08-08',
    readTime: '11分钟',
    tags: ['玩家评价', '社区讨论', '口碑', '回顾'],
  },
  {
    id: 'yosuga-music-analysis',
    title: '缘之空音乐赏析：那些让你心碎的BGM背后的故事',
    category: '主题评测',
    excerpt: '缘之空的配乐被誉为视觉小说音乐的典范之作。本文从音乐理论和情感表达两个维度，深度分析游戏中最具代表性的几首BGM，以及它们如何服务于叙事。',
    content: `<p>好的配乐是视觉小说的灵魂。《缘之空》的音乐由多位日本知名作曲家联手打造，在烘托氛围、表达情感方面达到了极高的水准。</p>

<h2>主题曲：命运的旋律</h2>
<p>缘之空的主题曲以其悠扬的钢琴旋律开场，随后弦乐渐入，营造出一种既温暖又忧伤的氛围。这种矛盾的音乐表达恰好呼应了故事的核心——在美好的夏日时光中，隐藏着无法回避的惆怅。</p>

<h2>日常曲：奥木染町的午后</h2>
<p>游戏中最常出现的日常BGM，以轻快的吉他分解和弦为主，配以柔和的电子音色。这首曲子成功地营造出了乡村小镇慵懒而宁静的夏日氛围。每当这首BGM响起，玩家便能感受到那种"时间在此刻静止"的奇妙体验。</p>

<h2>催泪曲：不能说出的名字</h2>
<p>这首BGM几乎成为了缘之空催泪场景的标配。简单的钢琴独奏，缓慢的节奏，偶尔插入的弦乐长音——极简的编配却带来了极强的情感冲击力。每当这首曲子响起，玩家就知道——感动的时刻即将到来。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Vintage%20gramophone%20on%20wooden%20table%20with%20sheet%20music%20scattered%20around%2C%20soft%20warm%20lighting%2C%20nostalgic%20music%20room%20atmosphere%2C%20cherry%20blossom%20petals%20on%20floor%2C%20elegant%20composition&width=1600&height=900&seq=yosuga-music-01&orientation=landscape',
    author: '悠之空编辑部',
    date: '2026-08-10',
    readTime: '9分钟',
    tags: ['主题评测', '音乐赏析', 'BGM', '配乐'],
  },
  {
    id: 'beginner-guide',
    title: '缘之空新手入门指南：从零开始的视觉小说体验',
    category: '剧情攻略',
    excerpt: '为从未接触过缘之空的新玩家准备的全面入门指南，包括游戏版本选择、安装教程、操作说明，以及推荐的游玩顺序和注意事项。',
    content: `<p>欢迎来到奥木染町！如果你刚刚决定开始体验《缘之空》这部作品，本文将是你的最佳起点。</p>

<h2>版本选择指南</h2>
<p>缘之空有多个版本，包括原版PC版、后续移植版以及各类汉化版本。对于中文玩家来说，推荐使用已安装完整汉化补丁的PC版本，这样可以获得最佳的文字阅读体验。</p>

<h2>游玩前须知</h2>
<p>在开始游玩之前，有几件事需要了解：首先，缘之空包含成人向内容，请确保你已年满18周岁；其次，游戏中涉及一些敏感的伦理议题，请以开放的心态去理解和感受；最后，建议准备充裕的时间——完整体验所有路线大约需要30-40小时的游戏时间。</p>

<h2>推荐游玩顺序</h2>
<p>对于新手玩家，我们推荐以下游玩顺序：共通线 → 瑛线 → 奈绪线 → 一叶线 → 初佳线 → 穹线。这个顺序是按照剧情揭示的渐进性设计的，可以帮助你更好地理解整个故事的全貌。</p>`,
    image: 'https://readdy.ai/api/search-image?query=Cozy%20gaming%20setup%20with%20laptop%20on%20wooden%20desk%2C%20headphones%20beside%2C%20warm%20lamp%20light%2C%20window%20showing%20summer%20countryside%2C%20peaceful%20atmosphere%2C%20minimalist%20Japanese%20room&width=1600&height=900&seq=yosuga-beginner-01&orientation=landscape',
    author: '悠之空编辑部',
    date: '2026-07-10',
    readTime: '8分钟',
    tags: ['剧情攻略', '新手入门', '版本选择', '游玩指南'],
  },
];

export const siteInfo = {
  name: '悠之空',
  fullName: '缘之空——命运交织的感动视觉小说体验',
  description: '探索「缘之空」的深刻世界——这部充满争议与感动的视觉小说，以细腻笔触描绘禁忌情感与命运羁绊。了解缘之空的剧情、角色、主题解析及玩家评价，感受那跨越界限的纯粹情感冲击。',
  url: 'https://kengame3.github.io',
  foundingYear: '2024',
};

export const reputationItems = [
  { label: '原创文章', value: '200+' },
  { label: '忠实读者', value: '50,000+' },
  { label: '社区评分', value: '4.9/5.0' },
  { label: '累计阅读', value: '100万+' },
];

export const faqItems = [
  {
    question: '缘之空适合什么样的玩家？',
    answer: '缘之空适合对深度情感叙事感兴趣的视觉小说爱好者。作品涉及成人内容和敏感伦理议题，建议18岁以上、具备成熟判断力的玩家体验。如果你喜欢细腻的心理描写和富有诗意的叙事风格，缘之空将带给你非凡的阅读体验。',
  },
  {
    question: '缘之空有哪些版本？中文版在哪里获取？',
    answer: '缘之空有PC原版、主机移植版等多个版本。中文玩家可以通过汉化补丁体验完整的中文内容。我们建议通过正规渠道购买原版游戏以支持开发者，然后安装社区汉化补丁获得最佳体验。',
  },
  {
    question: '游戏的推荐攻略顺序是什么？',
    answer: '我们推荐按照"瑛线 → 奈绪线 → 一叶线 → 初佳线 → 穹线"的顺序进行攻略。这个顺序按照剧情揭示的渐进性设计，能够帮助您逐步深入地理解整个故事的全貌。每条路线都有其独特的魅力，建议不要跳过任何一条。',
  },
  {
    question: '缘之空为什么有这么大的争议？',
    answer: '缘之空的争议主要源于其对禁忌情感的大胆描写，尤其是穹线中涉及的伦理议题。然而，如果从文学和艺术的角度来看，这些元素是作者探索人性边界和情感本质的叙事工具。作品的艺术价值已经经受住了时间的考验，建议以开放包容的心态去理解和感受。',
  },
];